import { isProjectReadOnly } from 'src/data/project';

import { useCurrentProject } from './useCurrentProject';

export const useIsProjectReadOnly = (): boolean => {
  const currentProject = useCurrentProject();
  return isProjectReadOnly(currentProject);
};
